import useGet from "../useGet";

export type MoneyCorpPermissions = {
  admin: boolean;
  resetPassword: boolean;
  processing: boolean;
  invoicing: boolean;
  invoicesRead: boolean;
  orderRaising: boolean;
  readCompanies: boolean;
  readBranches: boolean;
  cancelling: boolean;
};

const usePermissions = (): MoneyCorpPermissions => {
  const { value } = useGet(
    "/api/Permissions?ts=" + new Date().getTime(),
    "Unable to read permissions",
    []
  );

  return {
    admin: value.includes("Administration"),
    resetPassword: value.includes("ResetPassword"),
    processing: value.includes("Processing"),
    invoicing: value.includes("Invoicing"),
    invoicesRead: value.includes("Invoices.Read"),
    orderRaising: value.includes("Orders.Raise"),
    readCompanies: value.includes("Companies.Read"),
    readBranches: value.includes("Branches.Read"),
    cancelling: value.includes("Cancelling")
  };
};

export default usePermissions;
